.<template>
  <v-container fluid fill-height class="p-0">
    <v-row align="center" justify="center" class="background-container">
      <v-col cols="12" md="8" sm="6" xs="4">
       <sign-in/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SignIn from '../components/AppAccess/SignIn.vue'
export default {
components:{SignIn}
};
</script>

<style>

</style>